import root from 'window-or-global';

import locator from 'utils/locator';
import { session } from 'utils/storage';
import { getFeatureFlags } from 'utils/feature-flags';
import { consoleInfo } from 'utils/logging';

const MonetateSessionStateId = 'wtr-monetateq';

function excludeExternal(): boolean {
  const { checkout_excludeExternal: flag } = getFeatureFlags() ?? {};
  return !!flag;
}

function replayMonetateEvents() {
  if (!locator.pathname.endsWith('/checkout')) {
    const events = session.getJson<unknown[]>(MonetateSessionStateId);

    const debug = new URLSearchParams(locator.search).has('debug');
    if (debug) {
      consoleInfo('Replaying monetate events', JSON.stringify(events));
    }

    // clear the events to avoid rehydrating them again
    session.remove(MonetateSessionStateId);
    if (events?.length && root.monetateQ?.push) {
      // send the stashed events to the root monetateQ (avoid the wrapper module)
      events.forEach(event => {
        if (debug) {
          consoleInfo('monetateQ push', JSON.stringify(event));
        }
        root.monetateQ?.push(event);
      });
    }
  }
}

function addMonetateProxy() {
  if (locator.pathname.endsWith('/checkout')) {
    // clear any previous events
    session.remove(MonetateSessionStateId);

    // If we have the stubbed monetateQ push function already injected then we must wrap it
    const existingMonetateQPush = root.monetateQ?.push?.bind(root.monetateQ);
    const debug = new URLSearchParams(locator.search).has('debug');

    root.monetateQ = {
      push: function recordMonetateEvent(...args: unknown[]) {
        if (debug) {
          consoleInfo('Recording monetate event', JSON.stringify(args));
        }
        const events = session.getJson<unknown[]>(MonetateSessionStateId) ?? [];
        session.setJson(MonetateSessionStateId, [...events, ...args]);

        // call the original monetateQ push function, if it exists (to allow logging from browser extensions)
        existingMonetateQPush?.(...args);
      },
    };
  }
}

export function addThirdpartyScriptProxies() {
  if (!__SERVER__ && excludeExternal()) {
    replayMonetateEvents();
    addMonetateProxy();
  }
}
